var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from "lit/decorators.js";
import { html, LitElement } from "lit";
import headerCss from "./header.css.js";
let HeaderComponent = class HeaderComponent extends LitElement {
    constructor() {
        super();
        this.name = 'pb33f';
        this.url = 'https://pb33f.io';
        this.wide = false;
    }
    render() {
        return html ` 
            <header class="pb33f-header">
                <div class="logo ${this.wide ? 'wide' : ''}">
                    <span class="caret">$</span>
                    <span class="name"><a href="${this.url}">${this.name}</a></span>
                </div>
                <div class="header-space">
                    <slot></slot>
                </div>
            </header>`;
    }
};
HeaderComponent.styles = headerCss;
__decorate([
    property()
], HeaderComponent.prototype, "name", void 0);
__decorate([
    property()
], HeaderComponent.prototype, "url", void 0);
__decorate([
    property({ type: Boolean })
], HeaderComponent.prototype, "wide", void 0);
HeaderComponent = __decorate([
    customElement('pb33f-header')
], HeaderComponent);
export { HeaderComponent };
